import { bookTOC, PageNode } from "../data/bookTOC";

export function findPageByPath(path: string, toc = bookTOC): PageNode | null {
    for (const node of toc) {
        if (`/${node.slug}` === path) {
            return node;
        }
        if (node.subchapters) {
            const found = node.subchapters.find(child => `/${child.slug}` === path);
            if (found) {
                return found;
            }
        }
    }
    return null;
}

export function flattenTOC(toc = bookTOC): (PageNode & { path: string })[] {
    const result: (PageNode & { path: string })[] = [];

    for (const chapter of toc) {
        const chapterPath = `/${chapter.slug}`;
        result.push({ ...chapter, path: chapterPath });

        if (chapter.subchapters) {
            for (const sub of chapter.subchapters) {
                const subPath = `${chapterPath}/${sub.slug}`;
                result.push({ ...sub, path: subPath });
            }
        }
    }

    return result;
}

export function getPrevNext(path: string) {
    const flat = flattenTOC();
    console.log(flat)
    const idx = flat.findIndex(node => node.path === path);
    console.log(idx)
    return {
        prev: idx > 0 ? flat[idx - 1] : null,
        next: idx < flat.length - 1 ? flat[idx + 1] : null,
    }
}